import { BASE_NAME } from "../../config";
import { isDal } from "../../theme/ThemeStore";

const supportsNotifications = () => {
    return "Notification" in window;
};

const isNotificationGranted = () => {
    return supportsNotifications() && Notification.permission === "granted";
};

export const requestNotificationPermission = () => {
    if (!isNotificationGranted()) {
        Notification.requestPermission();
    }
};

export const notify = (title: string, body: string) => {
    if (isNotificationGranted()) {
        const icon = isDal() ? `${BASE_NAME}/favicon_dal.ico` : `${BASE_NAME}/favicon_aaa.png`;
        new Notification(title, { body, icon });
    }
};
